// @flow
import styled from '@emotion/styled'
import * as React from 'react'

import { colors } from '@toggl/style'

import { SectionBlock } from './SectionBlock'

export const SectionIceCream = styled<{
  ...React.ElementConfig<typeof SectionBlock>,
  bottom?: string,
  top?: string,
}>(SectionBlock)`
  background: linear-gradient(
    to bottom,
    ${(p) => p.top || colors.fadedPurple} 50%,
    ${(p) => p.bottom || colors.fadedPurpleAlt} 50%
  );
`
